import _slicedToArray from "/Users/jquense/src/react-formal/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from 'react';
import useCallbackRef from '@restart/hooks/useCallbackRef';
import ErrorBoundary from './ErrorBoundary';
import { useElement, useError } from './Provider';
var holderjs;

if (typeof window !== 'undefined') {
  holderjs = require('holderjs');
}

var Preview = function Preview(_ref) {
  var className = _ref.className,
      holderTheme = _ref.holderTheme;

  var _useCallbackRef = useCallbackRef(),
      _useCallbackRef2 = _slicedToArray(_useCallbackRef, 2),
      example = _useCallbackRef2[0],
      attachRef = _useCallbackRef2[1];

  var hasTheme = !!holderTheme;
  var element = useElement();
  var error = useError();
  useEffect(function () {
    holderjs.addTheme('userTheme', holderTheme); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasTheme]);
  useEffect(function () {
    if (!example) return;
    holderjs.run({
      theme: hasTheme ? 'userTheme' : undefined,
      images: example.querySelectorAll('img')
    });
  }, [element, example, hasTheme]); // prevent links in examples from navigating

  var handleClick = function handleClick(e) {
    if (e.target.tagName === 'A' || e.target.closest('a')) e.preventDefault();
  };

  return error ? null :
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
  React.createElement("div", {
    role: "region",
    "aria-label": "Code Example",
    ref: attachRef,
    className: className,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    element: element
  }));
};

export default Preview;